import { Avatar, AvatarFallback, AvatarImage } from "@do/ui/components/avatar";
import { cn } from "@do/ui/lib/utils";
import { useChat } from "../../providers/chat-provider";

export const HeaderAvatar = () => {
  const { chatbotParams } = useChat();

  return (
    <Avatar
      id="header-avatar"
      className={cn(
        "size-(--header-avatar-size)",
        "bg-(--header-avatar-background)",
        "rounded-(--header-avatar-border-radius)",
        "border-(--header-avatar-border-color)/(--header-avatar-border-opacity) border-(length:--header-avatar-border-width)"
      )}
    >
      <AvatarImage alt="Logo" id="header-avatar-image" src={chatbotParams.logoDataUri} />
      <AvatarFallback
        id="header-avatar-fallback"
        className="rounded-(--header-avatar-border-radius) bg-(--header-avatar-fallback-background) text-(--header-avatar-fallback-foreground)"
      />
    </Avatar>
  );
};
